import React from 'react';
import { Box, Container, Typography, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';

const CustomerService: React.FC = () => {
  const { t } = useTranslation();
  
  const handleAppStoreClick = () => {
    window.open('https://apps.apple.com/hk/app/hatsuhiken/id6747922311?l=en-GB', '_blank', 'noopener,noreferrer');
  };

  const handleGooglePlayClick = () => {
    window.open('https://play.google.com/store/apps/details?id=com.hatsuhikenapp&hl=en', '_blank', 'noopener,noreferrer');
  };
  
  return (
  <Container
    maxWidth="lg"
    sx={{
      display: 'flex',
      flexDirection: { xs: 'column', md: 'row' },
      alignItems: 'stretch',
      gap: 4,
      mt: 4,
      borderRadius: 3,
      p: 4,
    }}
  >
    {/* Left Side: Customer Service */}
    <Box
      sx={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'start',
        p: 2,
      }}
    >
      <Typography variant="h5" fontWeight={700} mb={2}>
        {t('customerService.title')}
      </Typography>
      <Typography variant="body1" mb={1} color="text.secondary">
        {t('customerService.emailAddress')}
      </Typography>
      <Typography variant="body1" mb={3}>
        cs@hatsuhiken.com
      </Typography>
      <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
        <Button
          variant="outlined"
          onClick={handleAppStoreClick}
          sx={{
            minWidth: 140,
            backgroundColor: '#FFFCF6',
            borderColor: 'transparent',
            color: '#17110D',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            p: 1,
          }}
        >
          <img 
            src="/icons/apply_store_download.svg" 
            alt="App Store" 
            width={140} 
          />
        </Button>
        <Button
          variant="outlined"
          onClick={handleGooglePlayClick}
          sx={{
            minWidth: 140,
            backgroundColor: '#FFFCF6',
            borderColor: 'transparent',
            color: '#17110D',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            p: 1,
          }}
        >
          <img 
            src="/icons/play_store_download.svg" 
            alt="Play Store" 
            width={140} 
          />
        </Button>
      </Box>
    </Box>
    {/* Right Side: App Promo */}
    <Box
      sx={{
        flex: 5,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <img
        src="/images/img_hatsuhiken_app.svg"
        alt="Hatsuhiken App"
        width={'100%'}
        height={250}
        style={{ maxWidth: '100%', height: 'auto', borderRadius: 16 }}
      />
    </Box>
  </Container>
  );
};

export default CustomerService; 
